import React, { Component } from "react";
import classnames from "classnames";
import "react-responsive-modal/styles.css";
import Form from "react-bootstrap/Form";
// import Row from "react-bootstrap/Row";
import { Modal } from "react-responsive-modal";
import { PopupActionButton } from "../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import {
  NewInputText,
  SelectBoxMUiInputComponent,
} from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../../store/actions/errorActions";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import {
  super_admin_diner_status_change,
  get_all_vendor_seating_information,
  get_all_vendor_pending_information,
} from "../../../../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import store from "../../../../../../store/store";
import { SET_VENDOR_INFORMATION } from "../../../../../../store/types";
import isEmpty from "../../../../../../store/validation/is-Empty";

const reasonData = [
  { id: 1, name: "No Seats", value: "No Seats" },
  { id: 2, name: "Walkaway", value: "Walkaway" },
  { id: 3, name: "Left Before Seating", value: "Left Before Seating" },
  { id: 4, name: "Other", value: "Other" },
];

export class SuperAdminReasonForCancellation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      cancelReservationData: "",
      enter_reason: "",
      diner_id: "",
      vendor_id: "",
      allData: {},
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.allDataProps) !== nextState.diner_id) {
      return {
        diner_id: nextProps.allDataProps._id,
        vendor_id: nextProps.allDataProps.vendor_id,
        allData: nextProps.allDataProps,
      };
    }
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/

  onSubmitHandler = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const diner_id = this.state.diner_id;
    // const vendor_id = this.state.vendor_id;
    if (this.props.cancelActionCall === "pendingSide") {
      const formData = {
        diner_status: "REJECTED",
        cancelReason:
          this.state.cancelReservationData === "Other"
            ? this.state.enter_reason
            : this.state.cancelReservationData,
      };
      this.props.super_admin_diner_status_change(
        formData,
        diner_id,
        // vendor_id,
        token,
        this.onCallBackFunc
      );
    } else {
      const formData = {
        diner_status: "CANCELLED",
        cancelReason:
          this.state.cancelReservationData === "Other"
            ? this.state.enter_reason
            : this.state.cancelReservationData,
      };
      this.props.super_admin_diner_status_change(
        formData,
        diner_id,
        // vendor_id,
        token,
        this.onCallBackFuncSuccess
      );
    }
  };

  onCallBackFunc = (e) => {
    const data = { vendor_id: this.state.vendor_id };
    this.props.get_all_vendor_pending_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
    this.props.closedMainModal();
  };

  onCallBackFuncSuccess = (e) => {
    const data = { vendor_id: this.state.vendor_id };
    this.props.get_all_vendor_seating_information(data);
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: this.state.allData,
    });
    this.onCloseModal();
    this.props.closedMainModal();
  };

  render() {
    const { open, errors, cancelReservationData } = this.state;
    return (
      <div>
        <PopupActionButton
          buttonText={this.props.buttonText}
          buttonType="button"
          buttonClass="yesButton"
          onClick={this.onOpenModal}
        />
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            // closeButton: "customCloseButtonCalling",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="reusable-popup-header-newstyle">
            <h4>Reason for Cancellation</h4>
          </div>
          <div className="reason-for-cancellation p-0">
            <Form>
              <div className="mt-4">
                <SelectBoxMUiInputComponent
                  extraClass={false}
                  selectLabel="Select Reason"
                  name="cancelReservationData"
                  value={this.state.cancelReservationData}
                  onChange={this.onChange}
                  getData={reasonData}
                  errorText={errors.cancelReservationData}
                  errorTrue={errors.cancelReservationData === "" ? true : false}
                />
              </div>
              {cancelReservationData === "Other" ? (
                <NewInputText
                  name="enter_reason"
                  onChange={this.onChange}
                  rows="4"
                  multiline={true}
                  value={this.state.enter_reason}
                  labelText="Enter Reason"
                  controlClass={"outlined-helperText "}
                />
              ) : null}
              <div className="mt-5 d-flex">
                <ReusableOnboardingButton
                  buttonTitle="Cancel Button"
                  buttonClass={
                    "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                  }
                  buttonText="Cancel"
                  onClick={this.onCloseModal}
                  buttonType="button"
                />
                <ReusableOnboardingButton
                  buttonTitle="Save"
                  buttonClass={
                    this.state.cancelReservationData === "" &&
                    this.state.enter_reason === ""
                      ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
                      : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  }
                  buttonText="Save"
                  onClick={
                    this.state.cancelReservationData === "" &&
                    this.state.enter_reason === ""
                      ? () => {}
                      : this.onSubmitHandler
                  }
                  buttonType="button"
                />
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

SuperAdminReasonForCancellation.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  super_admin_diner_status_change,
  get_all_vendor_seating_information,
  get_all_vendor_pending_information,
})(withRouter(SuperAdminReasonForCancellation));
